<div class="row container-form-list mb-3">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h6 class="card-title">
                    Concorrentes
                </h6>
                <small class="card-subtitle">Informe seus concorrentes presentes neste cliente</small>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th class="col-delete" *ngIf="canEdit"></th>
                            <th class="col-order" *ngIf="canEdit"></th>
                            <th class="col-sequencia text-center">#</th>
                            <th class="col-concorrente">Concorrente</th>
                            <th class="col-relevancia">Relevância</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-delete" *ngIf="canEdit">
                                <a class="btn btn-link" (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-order text-center" *ngIf="canEdit">
                                <span class="btn-group-vertical">
                                    <button type="button" class="btn btn-light" (click)="moverSequenciaParaCima(i)"><i class="fas fa-angle-up" aria-hidden="true"></i></button>
                                    <button type="button" class="btn btn-light" (click)="moverSequenciaParaBaixo(i)"><i class="fas fa-angle-down" aria-hidden="true"></i></button>
                                </span>
                            </td>
                            <td class="col-sequencia text-center">
                                {{entity.sequencia | decimalFormat: 1:0:0}}
                            </td>
                            <td class="col-concorrente">
                                <ng-container *ngIf="canEdit; else concorrenteSomenteLeitura">
                                    <sgt-concorrente-select
                                        #concorrenteSelect
                                        [ngModel]="entity.idConcorrente"
                                        (ngModelChange)="onConcorrenteChange(entity, $event)"
                                        [concorrenteVinculado]="entity.concorrente"
                                        [idsJaSelecionados]="idsSelecionadosExceto(i)"
                                        #concorrente="ngModel"
                                        name="concorrente_{{i}}"
                                        id="concorrente_{{i}}"
                                        [required]="true">
                                    </sgt-concorrente-select>
                                    <sgt-form-control-error
                                        *ngIf="concorrente.errors && concorrente.errors.required && concorrente.dirty"
                                        msgError="O concorrente é obrigatório">
                                    </sgt-form-control-error>
                                </ng-container>
                                <ng-template #concorrenteSomenteLeitura>
                                    {{entity.concorrente ? (entity.concorrente.codigo + ' - ' + entity.concorrente.nome) : '-'}}
                                    <span *ngIf="isConcorrenteInativo(entity)" class="badge badge-warning ml-1">Inativo</span>
                                </ng-template>
                            </td>
                            <td class="col-relevancia">
                                <ng-container *ngIf="canEdit; else relevanciaSomenteLeitura">
                                    <sgt-select
                                        #relevanciaSelect
                                        [(ngModel)]="entity.relevancia"
                                        [options]="opcoesRelevancia"
                                        #relevancia="ngModel"
                                        name="concorrenteRelevancia_{{i}}"
                                        id="concorrenteRelevancia_{{i}}"
                                        [required]="true">
                                    </sgt-select>
                                    <sgt-form-control-error
                                        *ngIf="relevancia.errors && relevancia.errors.required && relevancia.dirty"
                                        msgError="A relevância é obrigatória">
                                    </sgt-form-control-error>
                                </ng-container>
                                <ng-template #relevanciaSomenteLeitura>
                                    {{labelRelevancia(entity.relevancia)}}
                                </ng-template>
                            </td>
                        </tr>
                        <tr *ngIf="entities?.length === 0" class="no-record">
                            <td class="text-center" colspan="4">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum concorrente adicionado ao cliente
                            </td>
                        </tr>
                    </tbody>
                    <!-- <tfoot class="table-footer">
                        <tr>
                            <td colspan="3"></td>
                            <td class="col-perc-participacao text-right">
                                <span class="badge badge-primary">
                                    {{percParticipacaoTotal | decimalFormat: 1:2:2}}%
                                </span>
                            </td>
                            <td class="col-media-compra text-right">
                                <span class="badge badge-success">
                                    {{valorMediaCompraTotal | decimalFormat: 1:2:2}}
                                </span>
                            </td>
                        </tr>
                    </tfoot>                     -->
                </table>
            </div>
            <div class="card-footer" *ngIf="canEdit">
                <button type="button" class="btn btn-primary btn-sm" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Concorrente
                </button>
            </div>
        </div>
    </div>
</div>
